import '../Styles/Footer.css';
import { Link } from "react-router-dom";

function Footer(props) {

  return (
    <footer className='Footer'>
        <div className="Footer__texts">
           <h3>Matias Aguilar</h3>
           <p>{props.language === props.uk ? "Freelance Developer" : "Desarrollador Freelance"}</p>
        </div>
        <div className="Footer__links">
            <Link id='About' to="/" className='Footer__link'>{props.language === props.uk ? "Home" : "Inicio"}</Link>
            <Link id='Projects' to="/projects" className='Footer__link'>{props.language === props.uk ? "Projects" : "Proyectos"}</Link>
            <Link id='Studies' to="/studies" className='Footer__link'>{props.language === props.uk ? "Studies" : "Estudios"}</Link>
            <Link id='Contact' className="Footer__link" to="/contact">{props.language === props.uk ? "Contact" : "Contacto"}</Link>
        </div>
    </footer>
  );
}

export default Footer;